export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const tickIcon = require("../assets/check_circle_outline_24px.png");
export const errorIcon = require("../assets/report_gmailerrorred_24px.png");
export const mainImg = require("../assets/image_81702361.png");
export const homeIcon = require("../assets/button_tab_item.png");
export const mainImg2 = require("../assets/image_Frame8578.png");